import {stringify} from 'qs';
import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';

import {CACHE_MAX_AGE} from '../../utils/constants';

const namespace = 'PERFORMER_SEO_VENUES';
const MAX_EVENT_ROW = 30;
const venueLinksSelector = createSelector(
  (localState = {}) => localState.venueLinks,
  (venueLinks) => venueLinks
);

function loadVenues(searchParams, geo) {
  return (dispatch, getState) => {
    const state = getState();
    const opts = {
      geoExpansion: true,
      sort: 'distance asc',
      start: 0,
      rows: MAX_EVENT_ROW,
      parking: false,
      groupType: 'V',
      fieldlist: 'id',
      performerRole: 'homeTeam |awayTeam',
      ...searchParams,
    };

    delete opts.geo;

    if (geo && geo.key) {
      /**
       * Geo Location Section
       *
       */
      opts.point = geo.latitude && geo.longitude ? `${geo.latitude},${geo.longitude}` : null;
    }
    dispatch({type: 'SEO_VENUES_LOADING', loading: true, venueLinks: []});

    return get({
      host: process.env.REACT_APP_API_HOST,
      path: `/search/catalog/events/v3/eventGroupings?${stringify(opts)}`,
      json: true,
      cache: true,
      cacheMaxAge: CACHE_MAX_AGE,
      headers: {
        Authorization: process.env.REACT_APP_API_SECRET,
        'Accept-Language': state.lang,
      },
    }).then((body = {}) => {
      const venueLinks = body.numFound && body.groups ? getVenues(body.groups) : [];
      dispatch({type: 'SEO_VENUES_LOADED', venueLinks});

      return null;
    });
  };
}

function resetSeoPerformerVenues() {
  return (dispatch) => {
    dispatch({type: 'SEO_PERFORMER_VENUES_RESET', venueLinks: []});
  };
}

const controller = new Controller({
  namespace,

  reducers: ['SEO_PERFORMER_VENUES_RESET', 'SEO_VENUES_LOADING', 'SEO_VENUES_LOADED'],

  actionCreators: {
    resetSeoPerformerVenues,
    loadVenues,
  },
  mapStateToProps(state) {
    const localState = this.getLocalState(state);

    return {
      venueLinks: venueLinksSelector(localState),
      loading: localState.loading,
    };
  },
});

function getVenues(/* istanbul ignore next */ groups = []) {
  groups.forEach((item) => {
    item = {
      count: item.count,
      venueId: item.id,
      venueName: item.name,
      distance: item.events[0] ? item.events[0].distance : null,
      ...item,
    };

    return item;
  });

  return groups;
}

export default controller;
